import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/nav';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="site-container px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-bold font-heading text-white">南宫集团</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              创新驱动发展，品质铸就未来。南宫集团致力于为全球客户提供卓越的产品与服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">产品服务</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category?tab=tech" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">科技研发</Link></li>
              <li><Link to="/category?tab=invest" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">产业投资</Link></li>
              <li><Link to="/category?tab=trade" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">国际贸易</Link></li>
              <li><a href="#download" className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer">APP下载</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                <span>北京市朝阳区建国路88号南宫大厦</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-foreground-500"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-foreground-500"></i>
                <span>contact@nangong-group.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-time-line text-foreground-500"></i>
                <span>周一至周五 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 南宫集团 版权所有 |{' '}
            <a href="#" className="hover:text-foreground-300 transition-colors">京ICP备2024XXXXXXXX号</a>
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">服务协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}